// Catálogo de destinos/retailers para el modelo de captura por corrida.
// Mirror de la tabla `tiendas` (migración 00031). El destino (D1, Jeronimos) NO
// es el cliente (Alpina): el cliente ordena, la tienda es a dónde va el reempaque.
// Ver docs/spec-mvp/modelo/captura-tiendas.md
import { z } from 'zod';
/** Tienda/destino persistida (lo que devuelve el backend). */
export const tiendaSchema = z.object({
    id: z.string().uuid(),
    tenant_id: z.string().uuid(),
    codigo: z.string(),
    nombre: z.string(),
    es_activa: z.boolean(),
    created_at: z.string().datetime({ offset: true }),
    updated_at: z.string().datetime({ offset: true }),
});
/** Payload para crear una tienda (Coordinador/Admin en Configuración). */
export const tiendaCreateSchema = z.object({
    codigo: z.string().trim().min(1, 'Requerido').max(40, 'Máximo 40 caracteres'),
    nombre: z.string().trim().min(1, 'Requerido').max(120, 'Máximo 120 caracteres'),
    es_activa: z.boolean().default(true),
});
/** Payload para editar una tienda (al menos un campo). */
export const tiendaUpdateSchema = z
    .object({
    codigo: z.string().trim().min(1, 'Requerido').max(40, 'Máximo 40 caracteres').optional(),
    nombre: z.string().trim().min(1, 'Requerido').max(120, 'Máximo 120 caracteres').optional(),
    es_activa: z.boolean().optional(),
})
    .refine((o) => Object.keys(o).length > 0, { message: 'Debe modificar al menos un campo' });
/**
 * SKU mínimo para el dropdown de la planilla de tiendas. El backend acepta
 * cualquier SKU activo del tenant (no filtra por skus_lineas), así que el líder
 * elige de la lista completa de SKUs del tenant.
 */
export const tiendaSkuSchema = z.object({
    id: z.string().uuid(),
    codigo_cliente: z.string(),
    descripcion: z.string(),
});
/**
 * Fila de curación SKU×tienda (tabla tienda_skus, migración 00036). Define qué
 * SKUs aplican a cada destino + flags de insumo (sticker/termo). La meta es 500/h
 * por defecto (no se mide aún), así que NO va acá. Se gestiona en
 * Configuración → Tiendas → pestaña "Capacidades".
 */
export const tiendaSkuCatalogoSchema = z.object({
    id: z.string().uuid(),
    tienda_id: z.string().uuid(),
    sku_id: z.string().uuid(),
    sku_codigo: z.string(),
    sku_descripcion: z.string(),
    /** Cantidad de stickers por caja para este SKU en este destino (0 = no usa). */
    cantidad_stickers: z.number().int().min(0),
    /** Cantidad de termos por caja para este SKU en este destino (0 = no usa). */
    cantidad_termos: z.number().int().min(0),
    es_activo: z.boolean(),
});
/** Payload para curar (agregar) un SKU a un destino. */
export const tiendaSkuCreateSchema = z.object({
    tienda_id: z.string().uuid(),
    sku_id: z.string().uuid(),
    cantidad_stickers: z.number().int().min(0).max(99).default(0),
    cantidad_termos: z.number().int().min(0).max(99).default(0),
});
/** Payload para editar cantidades de insumo / estado de una curación (≥1 campo). */
export const tiendaSkuUpdateSchema = z
    .object({
    cantidad_stickers: z.number().int().min(0).max(99).optional(),
    cantidad_termos: z.number().int().min(0).max(99).optional(),
    es_activo: z.boolean().optional(),
})
    .refine((o) => Object.keys(o).length > 0, { message: 'Debe modificar al menos un campo' });
//# sourceMappingURL=tienda.js.map